DEBUG = false;

$(function() {

  $("#new-knack").on('click', function() {
    parent.$('body').trigger( 'new-knack' );
  });

  $(document).on('new-knack', function() {
    // DEBUG && console.log("KKFKF");
  });
});

// Constants for maker.js

// Pixel height for ruler image
var RULER_IMAGE_HEIGHT = 370;

// Default height for Knicks on the maker stage when not scaled to a ruler
var KNICK_DEFAULT_HEIGHT = 240;

// Pixel width for when knick carousel is launched and jar is clipped to the right side
// var MAKER_MAX_WIDTH = 700;

// Pixel width for right-hand utility panel
var UTIL_PANEL_WIDTH = 150;

// Flag for if the carousel has been loaded
var carouselLoaded = false;

var fetchProductInfo = function(handle, callback) {
  var args = [].slice.call(arguments, 2);
  if(handle) {
    $.get("/products/" + handle + "?view=metafields", function(data) {
      args.unshift(JSON.parse(data));
      callback.apply( null, args );
    }).fail(function() {
      args.unshift(undefined);
      callback.apply( null, args );
    });
  } else {
    args.unshift(undefined);
  	callback.apply( null, args );
  }
};

var createKnack = function(name,jar,knicks,callback) {
  var data = {};
  data.name = name;
  
  $.post("https://" + config.api.host + "/make",data,
  function(result, status) {
    callback(null,result.id);
  });
};

var createGiftMessage = function(knack_id,user_id,message,name,callback) {
  var data = {};
  data.knack_id = knack_id;
  data.user_id=user_id;
  data.message = message.replace(/(?:\r\n|\r|\n)/g, '\\n');
  data.name = name;
  $.post("https://" + config.api.host + "/group/gift/message",data,
  function(result, status) {
    callback(null,result.id);
  });
};

var firstRunPop = function(type, cb) {
  var frCookie = parent.getCookie('first_run') || '{}';
  var firstRuns = $.parseJSON(frCookie);
  firstRuns[type] = firstRuns[type] || { shows: 0 };
  if (firstRuns[type].shows < 2) {
    cb && cb.call(null, type);
    firstRuns[type].shows++;
  }
  parent.setCookie( 'first_run', JSON.stringify(firstRuns,null,0), 1000);
};

var deleteGroupComment = function(id,knack_id,user_id,callback) {
  
  var data = {};
  data.id = id;
  data.knack_id = knack_id;
  data.user_id = user_id;
  
  $.ajax({
    url: "https://" + config.api.host + '/group/gift/comment',
    type: 'DELETE',
    data: data,
    success: function(data) {
      if (typeof callback === "function") {
        callback(null,data);
      }
    },
    error: function(xhr, status, error) {
        callback(xhr.responseText);
    }
  });
};

var getNewComments = function(knack_id,last_comment_id,callback) {
  
  var data = {};
  data.knack_id = knack_id;
  data.last_id = last_comment_id;
  
  $.ajax({
    url: "https://" + config.api.host + '/group/gift/comment/new',
    type: 'GET',
    data: data,
    success: function(data) {
      if (typeof callback === "function") {
        callback(null,data);
      }
    },
    error: function(xhr, status, error) {
        callback(xhr.responseText);
    }
  });
};

var addGroupComment = function(id,message,first_name,last_name, created, can_remove) {
  
  var found = false;
  $('#comments ul li').each(function() {
	if($(this).data("id") == id) {
	  found = true;
	}
  });
  
  if(!found) {
	var html = '<li>';
	if (can_remove) {
	  html += '<div class="comment-delete"></div>';
	}
	html += '<h6>' + first_name + ' ' + last_name + ' <span class="created">' + created + '</span></h6><div class="bubble">' + message + '</div></li>';
	var comment = $(html);
	
	$(comment).data("id",id);
	$("#comments ul").prepend(comment);
	$('textarea#gift-comment').val('').blur();
  }
};

var addGiftMessage = function(message,name) {
  $("#knack-storybook-no-messages").hide();
  $("#knack-storybook-messages ul").append("<li><h3>" + message + "</h3>" + name + "<hr /></li>");
};

var createGiftTag = function(knack_id,title,message,message2,user_id,cookie_id,callback) {
  var data = {};
  data.knack_id = knack_id;
  data.title = title;
  data.message = message.replace(/(?:\r\n|\r|\n)/g, '\\n');
  data.message2 = message2.replace(/(?:\r\n|\r|\n)/g, '\\n');

  if (user_id) {
    data.user_id = user_id;
  }

  if(cookie_id) {
    data.cookie_id = cookie_id;
  }

  $.post("https://" + config.api.host + "/make/gifttag",data,
    function(result, status) {
      callback(null,result.id);
    });
};

var createStoryBook = function(knack_id,to,from,message, user_id, cookie_id,callback) {
  var data = {};
  data.knack_id = knack_id;
  data.from = from;
  data.to = to;
  data.message = message.replace(/(?:\r\n|\r|\n)/g, '\\n');

  if (user_id) {
    data.user_id = user_id;
  }

  if(cookie_id) {
    data.cookie_id = cookie_id;
  }

  $.post("https://" + config.api.host + "/make/storybook",data,
    function(result, status) {
      callback(null,result);
    });
};

var updateStoryBook = function(knack_id,to,from,message, user_id,cookie_id,callback) {
  var data = {};
  data.knack_id = knack_id;
  data.from = from;
  data.to = to;
  data.message = message.replace(/(?:\r\n|\r|\n)/g, '\\n');

  if (user_id) {
    data.user_id = user_id;
  }

  if(cookie_id) {
    data.cookie_id = cookie_id;
  }

  $.ajax({
    url: "https://" + config.api.host + '/make/storybook',
    type: 'PUT',
    data: data,
    success: function(data) {
      callback(null,data);
    },
    error: function(xhr, status, error) {
      var err = eval("(" + xhr.responseText + ")"); /* <- this is dangerous */
      callback(err.Message);
    }
  });
};

var updateGiftTag = function(knack_id,title,message,message2,user_id,cookie_id,callback) {
  var data = {};
  data.knack_id = knack_id;
  data.title = title;
  data.message = message.replace(/(?:\r\n|\r|\n)/g, '\\n');
  data.message2 = message2.replace(/(?:\r\n|\r|\n)/g, '\\n');

  if (user_id) {
    data.user_id = user_id;
  }

  if(cookie_id) {
    data.cookie_id = cookie_id;
  }

  $.ajax({
    url: "https://" + config.api.host + '/make/gifttag',
    type: 'PUT',
    data: data,
    success: function(data) {
      callback(null,data);
    },
    error: function(xhr, status, error) {
      var err = eval("(" + xhr.responseText + ")"); /* <- this is dangerous */
      callback(err.Message);
    }
  });
};

var updateKnack = function(id,name,user_id,cookie_id,callback) {
    var data = {};
    data.id = id;
    data.name = name;
    data.knicks = JSON.stringify(knicks);
    data.jar = JSON.stringify(jar);
    if (user_id) {
      data.user_id = user_id;
    }

  if(cookie_id) {
    data.cookie_id = cookie_id;
  }

  $.ajax({
    url: "https://" + config.api.host + '/make',
    type: 'PUT',
    data: data,
    success: function(data) {
      callback(null,data);
    },
    error: function(xhr, status, error) {
      var err = eval("(" + xhr.responseText + ")"); /* <- this is dangerous */
      callback(err.Message);
    }
  });
};

var deleteKnack = function(id,user_id,callback) {
  var data = {};
  data.id = id;

	if (user_id) {
    data.user_id = user_id;
  }
  
  $.ajax({
    url: "https://" + config.api.host + '/make',
    type: 'DELETE',
    data: data,
    success: function(data) {
      callback(null,data);
    },
    error: function(xhr, status, error) {
      var err = eval("(" + xhr.responseText + ")"); /* <- this is dangerous */
      callback(err.Message);
    }
  });
};

var ignoreCreatedKnack = function(id,user_id,callback) {
  var data = {};
  data.id = id;

  if (user_id) {
    data.user_id = user_id;
  }

  data.ignore = '1';

  $.ajax({
    url: "https://" + config.api.host + '/make/user/knack/created',
    type: 'PUT',
    data: data,
    success: function(data) {
      callback(null,data);
    },
    error: function(xhr, status, error) {
      var err = eval("(" + xhr.responseText + ")"); /* <- this is dangerous */
      callback(err.Message);
    }
  });
};

var assignKnackToUser = function(knack_id,user_id,email,callback) {
  var data = {};
  data.id = knack_id;
  data.user_id = user_id;
  data.email = email;

  $.ajax({
    url: "https://" + config.api.host + '/make/user',
    type: 'POST',
    data: data,
    success: function(data) {
      if (typeof callback === "function") {
        callback(null,data);
      }
    },
    error: function(xhr, status, error) {
      var err = eval("(" + xhr.responseText + ")"); /* <- this is dangerous */
      if (typeof callback === "function") {
        callback(err.Message);
      }
    }
  });
};

var assignKnackToCookie = function(knack_id,cookie_id,callback) {
  var data = {};
  data.id = knack_id;
  data.cookie_id = cookie_id;

  $.ajax({
    url: "https://" + config.api.host + '/make/cookie',
    type: 'POST',
    data: data,
    success: function(data) {
      if (typeof callback === "function") {
        callback(null,data);
      }
    },
    error: function(xhr, status, error) {
      var err = eval("(" + xhr.responseText + ")"); /* <- this is dangerous */
      if (typeof callback === "function") {
        callback(err.Message);
      }
    }
  });
};

var createGroupGift = function(knack_id,user_id,message,deadline,payments,callback) {
  var data = {};
  data.knack_id = knack_id;
  data.message = message.replace(/(?:\r\n|\r|\n)/g, '\\n');
  data.deadline = deadline;
  if (payments) {
    data.payments = "1";
  } else {
    data.payments = "0";
  }
  data.user_id = user_id;

  $.post("https://" + config.api.host + "/group/gift", data,
    function(result, status){
      callback(null,result);
    }
  );
};

var createGroupComment = function(knack_id,user_id,message,callback) {
  var data = {};
  data.knack_id = knack_id;
  data.message = message.replace(/(?:\r\n|\r|\n)/g, '\\n');
  data.user_id = user_id;

  $.post("https://" + config.api.host + "/group/gift/comment", data,
    function(result, status){
      callback(null,result);
    }
  );
};

var updateGroupGift = function(id,user_id,message,deadline,payments,email,callback) {

  var data = {};

  data.id = id;
  if(message) {
    data.message = message.replace(/(?:\r\n|\r|\n)/g, '\\n');
  }
    
  if(deadline) {
    data.deadline = deadline;
  }
  
  if (payments) {
    data.payments = payments;
  }
  
  if (email) {
    data.email = email;
  }

  data.user_id = user_id;

  $.ajax({
    url: "https://" + config.api.host + '/group/gift',
    type: 'PUT',
    data: data,
    success: function(data) {
      callback(null,data.id);
    },
    error: function(xhr, status, error) {
      var err = eval("(" + xhr.responseText + ")"); /* <- this is dangerous */
      callback(err.Message);
    }
  });
};

var addUserToGroupGiftList = function(email, name, id, can_edit, creator_id, viewed, payments, paid) {
     var uniqueId = Math.floor(Math.random()*10000) + '-' + Math.floor(Math.random()*10000) + '-' + Math.floor(Math.random()*10000) + '-' + Math.floor(Math.random()*10000);
     var item;
     item = '<li data-user-email="'+ email + '">' +
          '<div class="name">';

    if(name.trim() && name.length) {
        item += '<div>' + name;
    } else {
      item += '<div>' + email;
    }
    
    item += '</div>';
    
    if(creator_id == parent.customer) {
      item += '<div id="can-edit-container"><input id="' + uniqueId + '" class="user_edit can-edit-switch" type="checkbox" can_edit="' + can_edit + '"';

      if(can_edit == "1") {
        item += ' checked="checked" ';
      }

      item+= '/><label for="' + uniqueId + '">CAN EDIT <span id="switch-on">ON</span>/<span id="switch-off">OFF</span></label></div>';
    }

  item += '</div>' +
    '<div class="pay">';
   
  if (paid) {
      item += '<div class="pay-amount">Paid</div>';
  } else {
    if (viewed == "1") {
      item += '<div class="pay-amount">Viewed</div>';
    } else {
      item += '<div class="pay-amount">Invited</div>';
    }
  }
    
  item += '</div>';
  item += '</li>';

  $("#people-list").prepend(item);
};

var addUserGroupGiftPayments = function(email,amount,created) {
  $("#people-list li").each(function() {
    if($(this).data("user-email") == email) {
      var str = "Paid $" + amount;
      
      if(created) {
        str += ";" + created;
      }
      $(this).find(".pay-amount").html(str);
    }
  });
};

var inviteUserToGift = function(knack_id,email,user_id,title,deadline,message,invite_name,logo,email_bg,callback) {
  $.post("https://" + config.api.host + "/group/gift/invite",{logo:logo,email_bg: email_bg, id: knack_id, title:title, deadline:deadline,message:message,message:message,email: email,user_id:user_id,invite_name:invite_name},
    function(data, status){
      if (typeof callback === "function") {
        callback(null,data);
      }
    }
  );
};

var getJar = function() {
  return jar;
};

var getKnicks = function() {
  return knicks;
};

var existingMakerItems = [];
var startMakerWithItems = function(items,callback) {
  var requests = [];
  //fetchProductInfo(item.handle, handleProductResult, item);
  
  for (var i = 0; i < items.length; i++) {
    var item = items[i];
    
    if (!item.qty) {
      item.qty = 1;
    }
    
    for(var x=0; x < item.qty; x++) {
      existingMakerItems.push(item.variant_id);
    
      requests.push(function(item) {
        var dfd = jQuery.Deferred();
        
        fetchProductInfo(item.handle, function(result) {
          handleProductResult(result, item, function(err,item) {
            dfd.resolve(item);
          });
        });
        
        return dfd.promise();
      }(item));
    }
  }
  
  $.when.apply($, requests).done( function () {
    if (typeof callback === "function") {
      callback(arguments);
    }
  });
};

var handleProductResult = function(result, item, callback) {
  if ( !result ) {
    console.error("An error occured while loading item, please try again", result, item)
    if (typeof callback === "function") {
      callback(false);
    }
    return false;
  }

  if (result) {
    var found = false;

    for (var i = result.variants.length - 1; i >= 0; i--) {
      if (result.variants[i].id == item.variant_id) {
        found = true;
        var variant = result.variants[i];
        var product = result.product;

        var resultItem = {};
		if(item.id) {
		  resultItem.uid = item.id;
		}
        resultItem.product_id = product.id;
        resultItem.variant_id = variant.id;
        resultItem.price = variant.price;
        resultItem.variant_inventory_quantity = variant.inventory_quantity;
        resultItem.variant_available = variant.available;
        resultItem.currency = variant.price_currency;
        resultItem.product_title = product.title;
        resultItem.variant_title = variant.title;
        resultItem.handle = product.handle;

        if (variant.image) {
          resultItem.image = variant.image;
          resultItem.image_medium = variant.image_medium;
        } else {
          if (product.images[0]) {
            resultItem.image = product.images[0].image;
            resultItem.image_medium = product.images[0].image_medium;
          } else {
            resultItem.image = product.featured_image;
            resultItem.image_medium = product.featured_image_medium;
          }
        }

        resultItem.vendor = product.vendor;
        resultItem.vendor_handle = product.vendor_handle;
        resultItem.vendor_profile = product.vendor_profile;

        for (var kp in product.metafields) {
          if (product.metafields.hasOwnProperty(kp)) {
            resultItem[kp.replace("-","_")] = product.metafields[kp];
          }
        }

        for (var kv in variant.metafields) {
          if (variant.metafields.hasOwnProperty(kv)) {
            resultItem[kv.replace("-","_")] = variant.metafields[kv];
          }
        }

        if ( item.type == 'jar' ) {
          updateJar(resultItem, function(jar) {
            if (typeof callback === "function") {
              callback(false,jar);
            }
          });
        } else if ( item.type == 'knick' ) {
          knick = resultItem;
          addKnick(knick, function(knick) {
            if (typeof callback === "function") {
              callback(false,knick);
            }
          });
        }
      }
    }
    
    if (!found) {
      console.log("An error occured while loading " + item.type + " variant, please try again.", item);
      if (typeof callback === "function") {
        callback(false);
      }
      return false;
    }
  }
};


var largeEnoughJar = function(jar) {
  var fit = true;
  console.log(jar);
  for ( var i=0; i < knicks.length; i++ ) {
    fit = parent.knickFitInJar( knicks[i], jar );
    if (!fit) {
      // DEBUG && console.error("Knicks won't fit in jar", knicks[i], new_jar);
      break;
    }
  }

  // DEBUG && console.log('largeEnoughJar',fit);

  if ( !fit || knicksVolume(knicks) > jarVolume(jar) ) {
    upSellJar(knicks);
    return false;
  }

  return true;
};


var updateJar = function(new_jar,callback) {

  if(!largeEnoughJar(new_jar)) return;

  
  var requests = [];
  //Remove current jar.
  if (jar.uid) {
	requests.push(function(jar) {
	  var dfd = jQuery.Deferred();
	  
	  removeJarFromKnack($("#knack-designer").data('id'), jar.uid, function(err,id) {
		dfd.resolve();
	  });
	  
	  return dfd.promise();
	}(jar));
  }
  
  $.when.apply($, requests).done( function () {
	//Deleted jar, if needed.
	
	jar = new_jar; //Assign new jar
  
	var requests = [];
	
	//If we don't have a UID.  Create one.
	if(!jar.uid) {
      
	  requests.push(function(jar) {
		var dfd = jQuery.Deferred();
		
		addJarToKnack($("#knack-designer").data('id'), jar.variant_id, jar.product_id, jar.handle, function(err,id) {
		  jar.uid = id;
		  dfd.resolve(jar);
		});
		
		return dfd.promise();
	  }(jar));
	} else {
	  //Just pass back the knick.
	  requests.push(function(jar) {
		var dfd = jQuery.Deferred();
	  
		dfd.resolve(jar);
	  
		return dfd.promise();
	  }(jar));
	}
	
	$.when.apply($, requests).done( function (jar) {
      console.log(jar);
	  var $jarImg = $("<img src=" + jar.image + " />");
	  var $element = addMakerPopover(jar)
					  .append( $jarImg )
					  .data('width', jar.contain_width)
					  .data('length',jar.contain_length)
					  .data('height',jar.contain_depth)
					  .data('product-id', jar.product_id)
					  .data("variant-id", jar.variant_id);
	
	  $('#jar').html("");
	  $('#jar').append($element);
	  jar.$element = $element;
	  
	  var index = $.inArray(jar.variant_id.toString(), existingMakerItems);
	  if (index >= 0) {
		existingMakerItems.splice( index, 1 );
		// DEBUG && console.log('existingMakerItems',existingMakerItems);
	  }
	
      parent.$('body').trigger( 'update-jar',jar );
    
      if (typeof callback === "function") {
        callback(jar);
      }
	  runUpdates();
	});
  });
};


var updateRuler = function () {
  // DEBUG && console.group('%c----------- updateRuler() --------------------', "color:purple;font-weight:bold;");

  var jarHeight = Math.max(jar.contain_depth, jar.contain_length, jar.contain_width);
  // var jarWidth = Math.min(jar.contain_width, jar.contain_length);
  var rulerTop = jarHeight;
  jar.rulerTop = rulerTop;

  // Need to scale ruler if width greater than height,
  // because jar will not be to top of image.
  // if(jarHeight < jarWidth) {
  //   rulerTop = jarWidth;
  // }

  if ( !jar.rulerTop ) {
    rulerTop = 0;
    for (var i = knicks.length - 1; i >= 0; i--) {
      rulerTop = Math.max( parseFloat(knicks[i].height), rulerTop );
    }
  }

  scaleAllKnicks();

  knickContainerWidth = getKnickContainerWidth();
  if ( !jar.price || knickContainerWidth < ( $('#maker-knack-container').width() - UTIL_PANEL_WIDTH ) ) {
    $('#maker-knack-container img#ruler-left').show();
    $('#maker-knack-container img#ruler-right').hide();
    $('#maker-knack-container label').toggleClass('show-right', false );
    $('#maker-knack-container #jar').toggleClass('pin-right', false );
  } else if( knickContainerWidth > ( $('#maker-knack-container').width() - UTIL_PANEL_WIDTH ) ) {
    // Move ruler to right and activate the carousel
    $('#maker-knack-container img#ruler-right').show();
    $('#maker-knack-container img#ruler-left').hide();
    $('#maker-knack-container label').toggleClass('show-right', true );
    $('#maker-knack-container #jar').toggleClass('pin-right', true );
  }

  if( knickContainerWidth > ( $('#maker-knack-container').width() - UTIL_PANEL_WIDTH ) ) {
    renderMakerCarousel( true );
  } else {
    renderMakerCarousel( false );
  }

  $('label#ruler-top').html((rulerTop/1).toFixed(1) + '"');
  $('label#ruler-middle').html((rulerTop/2).toFixed(1) + '"');

  if ( jar.price ) {
    $('#maker-knack-container label').show();
  } else {
    $('#maker-knack-container label').hide();
  }

  // DEBUG && console.groupEnd();
};

var loadKnickImage = function(knick, cb) {
  // DEBUG && console.log( '%cloadKnickImage( %s )', "color:blue;", knick.product_title );
  var missingKnickImage = 'https://cdn.shopify.com/s/files/1/0965/7972/files/no-image.png';
  if ( knick.$element.length <= 0 ) { return false; }
  knick.$element.imagesLoaded()
    .done( function( instance ) {
      // DEBUG && console.log( '%cdone() knick loaded: %s', "color:blue;", knick.product_title );
      knick.imageLoaded = true;
      cb && cb.call(knick, instance);
    }).fail( function() {
      // DEBUG && console.log( '%cfail() knick failed: %s', "color:blue;", knick.product_title );
      var $knickImg = knick.$element.find('img');
      if ( $knickImg.attr('src') == missingKnickImage ) {
        // Likely a network error, so fetching a replacement image URL is useless.
        missingKnickImage = 'data:image/gif;base64,R0lGODlhAQABAPAAAO7u7gAAACwAAAAAAQABAEACAkQBADs=';
      }
      // DEBUG && console.log( '%crplacing knick image %s with %s', "color:blue;", $knickImg.attr('src'), missingKnickImage );
      $knickImg.replaceWith('<img src="' + missingKnickImage + '" />');
      // DEBUG && console.log('%cimg is now:', "color:blue;", knick.$element[0].outerHTML);
      cb && cb.call(knick);
    });
};


var scaleKnick = function(knick) {
  // DEBUG && console.log( '%cscaleKnick( %s )', "color:red;", knick.product_title );

  if ( !knick.imageLoaded ) {
    // DEBUG && console.log( '%c(!knick.imageLoaded), returning false: %s', "color:red;", knick.product_title );
    return false;
  }

  var rulerTop = jar.rulerTop,
      stageHeight = RULER_IMAGE_HEIGHT,
      knickWidth = parseFloat(knick.width),
      knickHeight = parseFloat(knick.height),
      $knickElement = knick.$element,
      $knickImg = $knickElement.find('img').first();

  if ( !jar.rulerTop ) {
    rulerTop = 0;
    for (var i = knicks.length - 1; i >= 0; i--) {
      rulerTop = Math.max( parseFloat(knicks[i].height), rulerTop );
    }
    stageHeight = KNICK_DEFAULT_HEIGHT;
  }

  $knickImg.css('visibility','hidden');

  var imgWidth = $knickImg[0].naturalWidth,
      imgHeight = $knickImg[0].naturalHeight;

  if( !imgWidth || !imgHeight ) {
    // DEBUG && console.log( '%c(!imgWidth || !imgHeight), returning false: %s', "color:red;", knick.product_title );
    return false;
  }

  knick.photoWidth = knick.photoWidth || imgWidth;
  knick.photoHeight = knick.photoHeight || imgHeight;

  knick.scaledHeight = ( knickHeight / rulerTop ) * stageHeight;
  knick.scaledWidth = ( knick.photoWidth / knick.photoHeight ) * knick.scaledHeight;
  $knickElement.data('scaled-width', knick.scaledWidth);
  $knickElement.find('img').first().height( knick.scaledHeight );

  // DEBUG && console.groupCollapsed( '%cscaling %c%s', 'font-weight: normal', 'font-weight: bold', knick.product_title );
  // DEBUG && console.log( 'knick data:   %fw x %fh. %f% of container height', knickWidth, knickHeight, ( knickHeight / rulerTop ) * 100 );
  // DEBUG && console.log( 'knick photo:  %dpx x %dpx. aspect ratio of %f', knick.photoWidth, knick.photoHeight, ( knick.photoWidth / knick.photoHeight ) );
  // DEBUG && console.log( 'knick scaled: %dpx x %dpx', knick.scaledWidth, knick.scaledHeight );
  // DEBUG && console.groupEnd();

  $knickImg.css('visibility','visible');

  return knick;
};

var scaleAllKnicks = function () {
  for (var i = knicks.length - 1; i >= 0; i--) {
    scaleKnick( knicks[i] );
  }
};


//  This function returns the scaled Width of the images.  Because there is no rule for how the images
//  are taken, this is assuming that the images are square, because this is the current case.  If the images
//  eventually become trimmed on the width to match the edges of the element, than scaling of this
//  width can easily be done.  But since the knick images have much white space on each side, than assuming
//  they are square is needed for now.
var getKnickContainerWidth = function () {
  var width = 0;
  var padding = 20;

  if(knicks.length)  {
    for (var i = 0; i < knicks.length; i++ )  {
      if(knicks[i].scaledWidth) {
        width += knicks[i].scaledWidth;
      } else {
        if(!jar.price) {
          width += 240;
        }
      }
      width += padding;
    }
  }

  // DEBUG && console.log('getKnickContainerWidth()', width, MAKER_MAX_WIDTH);
  return width;
};

var knicksVolume = function(knicks) {
    var current_fill = 0;
    for(var i=0; i < knicks.length; i++) {
      knick_volume = knicks[i].width * knicks[i].length * knicks[i].height;
      knick_volume -= knick_volume * knicks[i].compress;
      current_fill += knick_volume;
    }
    return current_fill;
};

var jarVolume = function(jar) {

    return (jar.contain_width * jar.contain_length * jar.contain_depth) * jar.max_fill;

    //return (Math.pow(Math.sqrt((jar.contain_diameter * jar.contain_diameter) / 2),2) * jar.contain_depth) * jar.max_fill;
};

var jarFillPercentage = function(jar,knicks) {
  if(knicks.length > 0) {
    if(jar.price) {
      var jar_v = jarVolume(jar);
      var knicks_c = knicksVolume(knicks);

      var volume = (knicks_c / jar_v) * 100;
      return volume.toFixed(0);
    } else {
      return 0;
    }
  } else {
    return 0;
  }
};

var roomForKnick = function(knick,jar) {
    var room = true;

    var knick_volume = knick.width * knick.length * knick.height;
    knick_volume -= knick_volume * knick.compress;
    var jar_volume = jarVolume(jar);
    var current_fill = knicksVolume(knicks);
	
    if (current_fill + knick_volume >= jar_volume) {
      room = false;
    }
    
    return room;
};

var upSellJar = function(knicks, callback) {

  var volume = 0;
  // DEBUG && console.log("UPSELL",knicks);
  for(var i=0; i < knicks.length; i++) {
  knick = knicks[i];
    knick_volume = knick.width * knick.length * knick.height;

    volume += (knick_volume) - (knick_volume * knick.compress);
  }

  parent.upSellJar(volume, knicks,function() {
    updateJar(jar, callback);
  });
};

var updateJarToMaker = function(jar,callback) {
  updateJar(jar,callback);
}

var addKnickToMaker = function(knick) {
  var dfd = jQuery.Deferred();
  addKnick(knick).then(function() {
    dfd.resolve();	
  });
  return dfd.promise();
};

var addKnickToKnack = function(knack_id, variant_id, product_id, handle, callback) {
  var data = {};
  data.knack_id = knack_id;
  data.variant_id = variant_id;
  data.product_id = product_id;
  data.handle = handle;
  
  $.ajax({
	url: "https://" + config.api.host + '/make/knick',
	type: 'POST',
	data: data,
	success: function(data) {
	  if(typeof callback === "function") {
		callback(null,data.id);
	  }
	},
	error: function(xhr, status, error) {
	  if(typeof callback === "function") {
		callback(error);
	  }
	}
  });
};

var addJarToKnack = function(knack_id, variant_id, product_id, handle, callback) {
  var data = {};
  data.knack_id = knack_id;
  data.variant_id = variant_id;
  data.product_id = product_id;
  data.handle = handle;
  
  $.ajax({
	url: "https://" + config.api.host + '/make/jar',
	type: 'POST',
	data: data,
	success: function(data) {
	  if(typeof callback === "function") {
		callback(null,data.id);
	  }
	},
	error: function(xhr, status, error) {
	  if(typeof callback === "function") {
		callback(error);
	  }
	}
  });
};

var removeKnickFromKnack = function(knack_id, uid, callback) {
  var data = {};
  data.knack_id = knack_id;
  data.id = uid;
  
  $.ajax({
	url: "https://" + config.api.host + '/make/knick',
	type: 'DELETE',
	data: data,
	success: function(data) {
	  if(typeof callback === "function") {
		callback(null,true);
	  }
	},
	error: function(xhr, status, error) {
	  if(typeof callback === "function") {
		callback(error);
	  }
	}
  });
};

var removeJarFromKnack = function(knack_id, uid, callback) {
  var data = {};
  data.knack_id = knack_id;
  data.id = uid;
  
  $.ajax({
	url: "https://" + config.api.host + '/make/jar',
	type: 'DELETE',
	data: data,
	success: function(data) {
	  if(typeof callback === "function") {
		callback(null,true);
	  }
	},
	error: function(xhr, status, error) {
	  if(typeof callback === "function") {
		callback(error);
	  }
	}
  });
};

var removeJarFromKnack = function(knack_id, uid, callback) {
  var data = {};
  data.knack_id = knack_id;
  data.id = uid;
  
  $.ajax({
	url: "https://" + config.api.host + '/make/jar',
	type: 'DELETE',
	data: data,
	success: function(data) {
	  if(typeof callback === "function") {
		callback(null,true);
	  }
	},
	error: function(xhr, status, error) {
	  if(typeof callback === "function") {
		callback(error);
	  }
	}
  });
};

var addKnick = function(knick,callback) {
  // DEBUG && console.log( '%caddKnick( %s )', "color:orange;", knick.product_title );
  var dfd = jQuery.Deferred();
  
  if( !parent.knickFitInJar(knick,jar) || !roomForKnick(knick,jar) ) {
    var tmp = $.extend(true, [], knicks);
    tmp.push(knick);
    upSellJar(tmp, function() {
      addKnick(knick).then(function() {
        dfd.resolve();
      });
    });
  } else {
	var requests = [];
	
	if(!knick.uid) {
	
	  requests.push(function(knick) {
		var dfd = jQuery.Deferred();
		
        if (!$("#knack-designer").data('id')) {
          saveKnack(parent.customer,parent.customer_email, function() {
            addKnickToKnack($("#knack-designer").data('id'), knick.variant_id, knick.product_id, knick.handle, function(err,id) {
              knick.uid = id;
              dfd.resolve(knick);
            });
          });
        } else {
          addKnickToKnack($("#knack-designer").data('id'), knick.variant_id, knick.product_id, knick.handle, function(err,id) {
            knick.uid = id;
            dfd.resolve(knick);
          });
        }
		
		return dfd.promise();
	  }(knick));
	} else {
	  //Just pass back the knick.
	  requests.push(function(knick) {
		var dfd = jQuery.Deferred();
	  
		dfd.resolve(knick);
	  
		return dfd.promise();
	  }(knick));
	}
	
	$.when.apply($, requests).done( function (knick) {
	  knicks.push(knick);
  
	  // For retina:
	  var image = knick.image || knick.image_medium;
	  // var image = knick.image_medium;
    
	  var $popElem = addMakerPopover(knick).append('<img src="' + image + '" />');
	  var $element = $('<li></li>').append($popElem).data('product-id', knick.product_id).data('variant-id', knicks.variant_id);

	  knick.$element = $element;
      
	  addKnickToCarousel(knick, function() {
        if (typeof callback === "function") {
          callback(knick);
        }
        dfd.resolve();
      });
      
	  var index = $.inArray(knick.variant_id.toString(), existingMakerItems);
	  if (index >= 0) {
		existingMakerItems.splice( index, 1 );
		// DEBUG && console.log('existingMakerItems',existingMakerItems);
	  }
  
	  runUpdates();
	});
  }
  
  return dfd.promise();
};


var currentJar = {};
var runUpdates = function() {
  if ( jar != currentJar ) {
    // DEBUG && console.log('%cnew jar: %O', "color:red;", jar);
    currentJar = jar;
    updateRuler();
  }
  updatePrice();

  if(existingMakerItems.length == 0) {
    popoverActions();
  }
};


var actions = 0;
var popoverActions = function() {
  if (actions > 2) return;

  switch (actions) {
    case 0:
      firstRunPop('nextStep', function(){
        setTimeout(function(){
          $('#next-step').alertPopover({
            placement: 'left auto',
            class: 'chevron rose',
            html: true,
            content: "Click to add items &amp; choose a container for your gift."
          });
        }, 3000);
      });
      break;
    case 1:
      firstRunPop('useFilters', function(){
        setTimeout(function(){
          parent.$('#filter-button .popover-anchor').alertPopover({
            placement: 'top auto',
            class: 'chevron green',
            html: true,
            content: "Use filters to view &amp; select items."
          });
        }, 3000);
      });
      break;
    case 2:
      firstRunPop('saveKnack', function(){
        setTimeout(function(){
          $('#save-knack').alertPopover({
            placement: 'left auto',
            class: 'chevron rose',
            html: true,
            content: "Save &amp; return to your Knacks any time! Go to Account > Saved & Faved."
          });
        }, 3000);
      });
      break;
  }
  actions++;
};


var updatePrice = function() {

  var total = 0.00;
  for(var i=0; i < knicks.length; i++) {
    total += parseFloat(knicks[i].price);
  }

  if (jar && jar.price) {
    total += parseFloat(jar.price);
  }

  $("#total-price").html("$" + total.toFixed(2));

  //See how much we have fulled.
  var fill = jarFillPercentage(jar,knicks);
  if(!fill) {
    fill = "0";
  }

  if (jar.price || knicks.length) {
    
    if ( $("#util-panel-wrapper").is(':hidden') ) {
      $("#start-knack").remove();
      //$("#maker-wrapper").addClass("show");
      $('#maker-knack-container').show();
      $("#knack-name").prop( 'disabled', false );
      $("#knack-name").removeAttr("readonly");
      if (!$("#knack-name").val()) {
        $("#knack-name").attr("placeholder","Name your Knack");
      }
      $("#util-panel-wrapper").show();
      $("#util-panel-wrapper").attr("style", "display:block");
    }
  }

  updatePercentage(fill);
};


var saveKnack = function(customer_id,email,callback) {
  if (!$("#knack-designer").data('id')) {
    createKnack($("#knack-name").val(),null,null, function(err,knack_id) {
        if (err) {
          callback(err);
        } else {
          console.log("ID",knack_id);
          assignKnackToCookie(knack_id,parent.getCookie("_shopify_y"), function(err, result) {
              // DEBUG && console.log("Auto saved Knack " + knack_id + " to cookie");
              $("#knack-designer").data('id',knack_id);
              parent.setCookie("knack_id",knack_id,1000);
              if(customer_id) {
                  assignKnackToUser(knack_id,customer_id,email,function(err, result) {
                    // DEBUG && console.log("Auto saved Knack " + knack_id + " to user");
                    $("#knack-designer").data('id',knack_id);
                    parent.setCookie("knack_id",knack_id,1000);
            
                    if (typeof callback === "function") {
                      callback(null,knack_id);
                    }
                    
                });
              } else {
                if (typeof callback === "function") {
                  callback(null,knack_id);
                }
              }
          });
        }
    });
  } else {
    if(customer_id) {
      assignKnackToUser($("#knack-designer").data('id'),customer_id,email);
    }
    
    updateKnack($("#knack-designer").data('id'),$("#knack-name").val(),customer_id,parent.getCookie("_shopify_y"), function(err) {
      if (typeof callback === "function") {
        callback(null, $("#knack-designer").data('id'));
      }
    });
  }
};

var saveGiftTag = function(knack_id,customer_id,callback) {
    if (!$("#knack-gift-tag").data("id")) {
      createGiftTag(knack_id,$("#knack-gift-tag-title").val(), $("#knack-gift-tag-message").val(), $("#knack-gift-tag-message-2").val(), customer_id, parent.getCookie("_shopify_y"), function(err,result) {
          if (err) {
          callback(err);
          } else {
          $("#knack-gift-tag").data("id",knack_id);
          callback(null,result);
          }
      });
    } else {
      updateGiftTag(knack_id,$("#knack-gift-tag-title").val(), $("#knack-gift-tag-message").val(), $("#knack-gift-tag-message-2").val(), customer_id, parent.getCookie("_shopify_y"), function(err,result) {
          if (err) {
          callback(err);
          } else {
          $("#knack-gift-tag").data("id",knack_id);
          callback(null,result);
          }
      });
    }
};

var saveStoryBook = function(knack_id,user_id,callback) {
    if (!$("#knack-storybook").data("id")) {
      createStoryBook(knack_id,$("#knack-storybook-to").val(),$("#knack-storybook-from").val(), $("#knack-storybook-message").val(), user_id, parent.getCookie("_shopify_y"), function(err,result) {
          if (err) {
            callback(err);
          } else {
            $("#knack-storybook").data("id",knack_id);
            callback(null,result);
          }
      });
    } else {
      updateStoryBook(knack_id,$("#knack-storybook-to").val(),$("#knack-storybook-from").val(), $("#knack-storybook-message").val(), user_id, parent.getCookie("_shopify_y"), function(err,result) {
          if (err) {
            callback(err);
          } else {
            $("#knack-storybook").data("id",knack_id);
            callback(null,result);
          }
      });
    }
};

var updateGroupUserView = function(knack_id,email,viewed,callback) {
  var data = {};
  data.viewed = viewed;
  data.email = email;
  data.knack_id = knack_id;
  $.ajax({
	url: "https://" + config.api.host + '/group/gift/user/view',
	type: 'PUT',
	data: data,
	success: function(data) {
		callback(null,data);
	},
	error: function(xhr, status, error) {
		var err = eval("(" + xhr.responseText + ")"); /* <- this is dangerous */
		callback(err.Message);
	}
  });
};

var updateUserEdit = function(knack_id,owner_id,email,can_edit,callback) {
  var data = {};

    data.knack_id = knack_id;
    data.owner_id = owner_id;
    data.email = email;
    data.can_edit = can_edit;

    $.ajax({
      url: "https://" + config.api.host + '/group/gift/user',
      type: 'PUT',
      data: data,
      success: function(data) {
          callback(null,data);
      },
      error: function(xhr, status, error) {
          callback(error);
      }
    });
};

var updateGroupGiftPayment = function(knack_id,user_id,payment,callback) {
  var data = {};

    data.knack_id = knack_id;
    data.user_id = user_id;
    data.payment = payment;
    data.paypal_email = email;

    $.ajax({
      url: "https://" + config.api.host + '/group/gift/payment',
      type: 'PUT',
      data: data,
      success: function(data) {
        callback(null,data);
      },
      error: function(xhr, status, error) {
        var err = eval("(" + xhr.responseText + ")"); /* <- this is dangerous */
        callback(err.Message);
      }
    });
};


var saveGroupGift = function(customer_id,callback) {
    if ($("#knack-designer").data('group-gift')) {

      var payments;
      if($("#activate-payments").is(":checked")) {
        payments = "1";
      } else {
        payments = "0";
      }
      
      updateGroupGift($("#knack-designer").data('id'),customer_id,$("#invite-message").val(),$("#invite-deadline").val(),payments, $("#paypal-email").val(),function(err,result) {
          if (err) {
			if (typeof callback === "function") {
			  callback(err);
			}
          } else {
			if (typeof callback === "function") {
			  callback(null,result);
			}
          }
      });
    } else {
	  createGroupGift($("#knack-designer").data('id'),customer_id,$("#invite-message").val(),$("#invite-deadline").val(),$("#activate-payments").is(":checked"), function(err, result) {
		  $("#knack-designer").data('group-gift',"true");
		  if (err) {
			if (typeof callback === "function") {
			  callback(err);
			}
		  } else {
			if (typeof callback === "function") {
			  callback(null,result);
			}
		  }
	  });
    }
};

var addKnickToCarousel = function (knick,callback) {
  // DEBUG && console.log( 'addKnickToCarousel( %s )', knick.product_title );
  var $knickContainer = $('div#maker-wrapper #maker-knack-container div#knicks');
  $knickContainer.toggleClass('loading', true);
  // DEBUG && console.log( '%cdo loadKnickImage( %s )', "color:green;", knick.product_title );
  loadKnickImage(knick, function(instance) {
    // DEBUG && console.log( '%cloadKnickImage( %s ) callback', "color:green;", knick.product_title );
    scaledKnick = scaleKnick(knick);
    if ( scaledKnick ) {
      // DEBUG && console.log( '%cscaledKnick valid', "color:green;" );
      // DEBUG && console.log( '%cappending %s', "color:green;", scaledKnick.product_title );
      
      $('#maker-knick-list').append( scaledKnick.$element );
     
      updateRuler();
      $knickContainer.toggleClass('loading', false);
      if ( $knickContainer.hasClass('jcarousel') ) {
        $knickContainer.jcarousel('reload');
        $knickContainer.jcarousel('scroll', scaledKnick.$element);
        // $knickContainer.jcarousel('scrollIntoView', elem, false);
        // $knickContainer.jcarousel('scroll', -1);
      }
      if (typeof callback === "function") {
        callback();
      }
    } else {
      addKnickToCarousel(knick,callback);
    }
  });
};

var removeKnickFromCarousel = function (knick) {
  // DEBUG && console.log( 'removeKnickFromCarousel( %s )', knick.product_title );
  (knick.$element.length > 0) && knick.$element.remove();
  updateRuler();
  var $knickContainer = $('div#maker-wrapper #maker-knack-container div#knicks');
  if($knickContainer.hasClass('jcarousel')) {
    $knickContainer.jcarousel('reload');
  }
};

var removeJarFromCarousel = function() {
  var $jarContainer = $('div#maker-wrapper #maker-knack-container div#jar');
  jar = {};
  $jarContainer.children().remove();
  $jarContainer.html('');
  updateRuler();
};


var renderMakerCarousel = function ( show ) {
  var $knickContainer = $('div#maker-wrapper #maker-knack-container div#knicks');

  if( show ) {

    $knickContainer.toggleClass('jcarousel', true);
    $knickContainer.find('#knack-carousel-prev-button').toggleClass('hide', false);
    $knickContainer.find('#knack-carousel-next-button').toggleClass('hide', false);
    if( !$knickContainer.data('jcarousel') ) {
      $knickContainer.on('jcarousel:reload jcarousel:create', function () {
        // Event for reloading and creating the carousel
        // DEBUG && console.log('%cjcarousel reloaded', "color:blue;");
      })

      // .on('jcarousel:reloadend', function(event, carousel) {
      //   $(this).jcarousel('items').each( function () {
      //     $(this).css('width', ($(this).data('scaled-width') + 20 + 'px'));
      //   });
      // })

      .jcarousel({
        // center: true,
        transitions: Modernizr.csstransitions ? {
          transforms:   Modernizr.csstransforms,
          transforms3d: Modernizr.csstransforms3d,
          easing:       'ease'
        } : false
      });

      // .jcarousel();

      $knickContainer.find('#knack-carousel-prev-button')
      .on('jcarouselcontrol:active', function() {
        $(this).show();
      })
      .on('jcarouselcontrol:inactive', function() {
        $(this).hide();
      })
      .jcarouselControl({
        target: '-=2'
      });

      $knickContainer.find('#knack-carousel-next-button')
      .on('jcarouselcontrol:active', function() {
        $(this).show();
      })
      .on('jcarouselcontrol:inactive', function() {
        $(this).hide();
      })
      .jcarouselControl({
        target: '+=2'
      });

      carouselLoaded = true;
    } else {
      $knickContainer.jcarousel('reload');
    }
  } else {
    $knickContainer.toggleClass('jcarousel', false);
    $knickContainer.find('#knack-carousel-prev-button').toggleClass('hide', true);
    $knickContainer.find('#knack-carousel-next-button').toggleClass('hide', true);
  }
};

var updatePercentage = function (percentFull) {
  /**
   Radial Dial for Percentage
   */
  var $donut = $('#knack-fill-percentage');

  var options = {
    percent:  percentFull,
    size: $donut.data('size') || 45,
    padding: 1,
    lineWidth: $donut.data('line') || 4,
    rotate: $donut.data('rotate') || 0
  };

  var $canvas = $("<canvas>").css({
    width: options.size,
    height: options.size,
  });
  var $centerPercent = $("<span>", { class: 'font-lato-bold'});
  var $label = $('<h5>').text('% FULL');

  $centerPercent.text(options.percent + '%');

  if (typeof(G_vmlCanvasManager) !== 'undefined') {
    G_vmlCanvasManager.initElement(canvas);
  }

  // Retina
  options.size = options.size * 2;
  options.padding = options.padding * 2;
  options.lineWidth = options.lineWidth * 2;

  var ctx = $canvas[0].getContext('2d');
  ctx.canvas.width = options.size + (options.padding * 2);
  ctx.canvas.height = options.size + (options.padding * 2);

  $donut.empty();
  $donut.append($centerPercent);
  $donut.append($canvas);
  $donut.append($label);

  ctx.translate(options.size / 2, options.size / 2); // change center
  ctx.rotate((-1 / 2 + options.rotate / 180) * Math.PI); // rotate -90 deg

  //imd = ctx.getImageData(0, 0, 240, 240);
  var radius = (options.size - options.lineWidth) / 2;

  var drawCircle = function(color, lineWidth, percent) {
    percent = Math.min(Math.max(0, percent || 1), 1);
    ctx.beginPath();
    ctx.arc(-options.padding, options.padding, radius, 0, Math.PI * 2 * percent, false);
    ctx.strokeStyle = color;
    ctx.lineCap = 'butt'; // butt, round or square
    ctx.lineWidth = lineWidth;
    ctx.stroke();
  };

  drawCircle('#B1B1B1', options.lineWidth, 100 / 100);
  drawCircle('#B4E4E0', options.lineWidth + 0.8, options.percent / 100);
};


var addMakerPopover = function(item) {
  var $popElem = $('<a tabindex="0" role="button">').css('outline','none');

  var priceLine = "$" + parseFloat(item.price).toFixed(2);
  if ( item.variant_title && item.variant_title != "Default Title" ) {
    priceLine = item.variant_title + " / " + priceLine;
  }

  if (item.variant_available) {
    var popContent = '<div><button type="button" id="close" class="close">&times;</button>' +
                   '<h4 class="font-lato-bold">' + item.product_title + '</h4>' + 
                   '<h5 class="font-lato-bold">' + priceLine + '</h5>' +
                   '<button id="edit" class="font-lato-bold">EDIT</button>' +
                   '<button id="remove" class="font-lato-bold">REMOVE</button></div>';
  } else {
    var popContent = '<div><h4 class="font-lato-bold">' + item.product_title + '</h4>' +
                      '<h5 class="font-lato-bold">';
    
                  if ( item.variant_title && item.variant_title != "Default Title" ) {
                    popContent +=  item.variant_title + '<br />';
                  }
                  
    popContent += item.vendor + '</h5>' +
                  '<h5 class="font-lato-bold">This product is out of stock and will be removed from your Knack.  Replace it with another treasure.</h5>' +
                   '<button id="remove" class="font-lato-bold">OK</button></div>';
  }

  $popElem.popover({
    html: true,
    content: popContent,
    placement: 'auto top',
    trigger: 'focus'
  });
  
  $popElem.on('hide.bs.popover', function() {
    parent.$('body').trigger( 'maker-hide-info',item );
    
  });
  
  $popElem.on('show.bs.popover', function() {
    parent.$('body').trigger( 'maker-show-info',item );
  });

  $popElem.on('inserted.bs.popover', function(){
    
    if (!item.variant_available) {
      $popElem.off('focusout.popover');
    }
    $popElem.data('bs.popover').$tip.on('click', function(event) {
      
      if ( $.inArray(event.target.id, ['remove', 'close']) === -1 ) {
        return false;
      }
      if (event.target.id == 'remove') {
        if ( item.rulerTop ) {
		  removeJarFromKnack($("#knack-designer").data('id'), item.uid);
          removeJarFromCarousel();
        } else {
          index = knicks.indexOf(item);
          (index > -1) && knicks.splice(index, 1);
		  
		  removeKnickFromKnack($("#knack-designer").data('id'), item.uid);
          removeKnickFromCarousel(item);
        }
        parent.$('body').trigger( 'maker-remove-item',item );
        
        updatePrice();
      }
      
      $popElem.popover('hide');
    }).on('mousedown touchstart', function(event) {
      $popElem.off('focusout.popover');
    });
  });

  item.$popElem = $popElem;
  return $popElem;
};